import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import DashboardLayout from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';
import { AuthGuard } from 'src/auth/guard';

import UserPage from 'src/pages/management/user/user';
import ProductPage from 'src/pages/management/product/product';
import ProductAmountPage from 'src/pages/management/product/product-amount';
import ProductDetailPage from 'src/pages/management/product/product-detail';
import UserEditPage from 'src/pages/management/user/user-edit';
import InviteCodePage from 'src/pages/management/invite-code/invite-code';
import InviteCodeCreatePage from 'src/pages/management/invite-code/invite-code-create';
import NotificationPage from 'src/pages/management/notification/notification';
import SettingPage from 'src/pages/management/setting/setting';

export const managementRoutes = [
  {
    path: 'management',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <UserPage />, index: true },
      { path: 'user', element: <UserPage /> },
      { path: 'product', element: <ProductPage /> },
      { path: 'product/:id/detail', element: <ProductDetailPage /> },
      { path: 'product/:id/amount', element: <ProductAmountPage /> },
      { path: 'user/:id/edit', element: <UserEditPage /> },
      { path: 'invite-code', element: <InviteCodePage /> },
      { path: 'invite-code/create', element: <InviteCodeCreatePage /> },
      { path: 'notification', element: <NotificationPage /> },
      { path: 'setting', element: <SettingPage /> },
    ],
  },
];
